import { prop } from 'ramda';
import React, { useCallback, useMemo } from 'react';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

import * as constants from 'js/components/main/BonusHistory/hooks/useTableHeader/constants';
import { useDynamicReducerDispatch, useDynamicReducerSelector } from 'js/components/main/BonusHistory/store';
import * as actions from './actions';

export const useTableHeader = () => {
    const dispatch = useDynamicReducerDispatch();
    const translate = useComponentTranslations();
    const isLoading = useDynamicReducerSelector(prop('isLoading'));

    const options = useMemo(() => constants.STATUS_FILTER_OPTIONS.map((item) => ({
        ...item,
        label: translate(item.label)
    })), [translate]);

    const onFilterChange = useCallback((event: React.ChangeEvent<HTMLSelectElement>): void => {
        const status = event.target.getAttribute('value');

        dispatch(actions.updateStatus(status as string));
    }, [dispatch]);

    return useMemo(() => ({
        filters: [{
            id: 0,
            options,
            name: 'status',
            disabled: isLoading,
            onChange: onFilterChange,
            label: translate('status.label'),
            'aria-label': translate(['status.label', 'playtech.mobile.system.select.aria-label'])
        }]
    }), [isLoading, translate, options, onFilterChange]);
};
